import React from "react";

import { LoadState } from "@/lib/scan-ui/screen";
import { BitrixCard } from "@/pages/settings/cards/BitrixCard";
import { InspectionRoutingCard } from "@/pages/settings/cards/InspectionRoutingCard";
import { OkkArbitrageCard } from "@/pages/settings/cards/OkkArbitrageCard";
import { OrgWhitelistCard } from "@/pages/settings/cards/OrgWhitelistCard";
import { SettingsPageHeader } from "@/pages/settings/SettingsPageHeader";
import { useSystemSettingsQuery } from "@/pages/settings/useSystemSettingsQuery";
import { usePortalConfig } from "@/portal/usePortalConfig";

/** Настройки приёмки поставок: фильтр организаций, маршрут входного контроля
 *  по группам номенклатуры, склад арбитражных образцов ОКК и задачи в Битрикс24.
 *
 *  Карточка ОКК — здесь, а не своей секцией: ОКК проверяет приход, секции
 *  настроек — реестр бэкенда (`settings_sections.py`), а одна карточка не
 *  стоит отдельной страницы. Раздел ОКК в профиле может отсутствовать при
 *  включённой приёмке — тогда его роутер не смонтирован (404), и карточки нет
 *  (как `transfer_check` на странице проверки заказов). */
export function ReceivingSettingsPage(): React.ReactElement {
  const { data, isLoading, error, refetch } = useSystemSettingsQuery();
  const { hasPage } = usePortalConfig();

  if (isLoading || error || !data) {
    return (
      <div className="mx-auto max-w-2xl space-y-6">
        <SettingsPageHeader
          title="Приёмка"
          subtitle="Организации в фильтре приёмки, маршрут входного контроля и задачи на проверку в Битрикс24."
        />
        <LoadState
          isLoading={isLoading}
          error={error}
          onRetry={() => void refetch()}
          className="flex flex-col items-center gap-3 p-4 text-center"
        />
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl space-y-6">
      <SettingsPageHeader
        title="Приёмка"
        subtitle="Организации в фильтре приёмки, маршрут входного контроля и задачи на проверку в Битрикс24."
      />
      <OrgWhitelistCard
        title="Организации в фильтре «Приёмка поставок»"
        field="receiving_org_refs"
        current={data.receiving_org_refs}
      />
      <InspectionRoutingCard />
      {hasPage("okk_receiving") && <OkkArbitrageCard />}
      <BitrixCard data={data} />
    </div>
  );
}
